import { render, staticRenderFns } from "./list-location.vue?vue&type=template&id=2d9746a1"
import script from "./list-location.vue?vue&type=script&lang=js"
export * from "./list-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports